import { defineMessages } from 'react-intl';

export const CONTROL_TYPES = {
    NUMBER: 'number',
    ARROW: 'arrow',
};

export const LOCALIZED_STRINGS = defineMessages({
    NumericalToggleHoverText: {
        id: 'Search.Page.Pagination.NumericalToggleHoverText',
        defaultMessage: 'Jump to search results page {index, number}',
    },

    NextToggleHoverText: {
        id: 'Search.Page.Pagination.NextToggleHoverText',
        defaultMessage: 'Jump to the next search results page ({index, number})',
    },

    PreviousToggleHoverText: {
        id: 'Search.Page.Pagination.PreviousToggleHoverText',
        defaultMessage: 'Jump to the previous search results page ({index, number})',
    },
});
